import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AutomateJobService } from './automate-job.service';

@Injectable()
export class ClassifierService {

  classifierCache: any = {};

  constructor(private http: HttpClient, private automateJobService: AutomateJobService) { }

  getClassifier(classifierId: string, useCache: boolean = false): Observable<any> {
    // some respond tasks won't have a classifierId but we still call this to avoid confusing code in the component. Return null
    // if there is no classifier
    if (!classifierId) {
      return null;
    }
    else {
      if (useCache && this.classifierCache[classifierId]) {
        return Observable.of(this.classifierCache[classifierId]);
      }
      else {
        return this.http
          .get(
            `/api/v1/classifier/${classifierId}`
          )
          .map( (response: any) => {
            this.classifierCache[classifierId] = response;
            return this.classifierCache[classifierId];
        });
      }
    }
  }

  getClassifierForJob(automateJobId: string) {
    return this.http
      .get(
        `/api/v1/classifier/job/${automateJobId}`
      );
  }

  getClassifierForCategory(categoryId: string) {
    return this.http
      .get(
        `/api/v1/classifier/category/${categoryId}`
      );
  }

  getBotClassifiers(type?: string): Observable<any> {
    return this.automateJobService.getJobs(type ? type : 'all').mergeMap(
      (result: any) => {
        const botJobs = result.filter((job: any) => job.type.indexOf('bot') > -1);
        return Observable
          .forkJoin(...botJobs.map((job: any) => this.getClassifierForJob(job._id)))
          .map(
            (classifiers) => (
              botJobs.map((job: any, i: number) => ({
                job,
                classifier: classifiers[i],
              }))
            )
          );
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/classifier.service.ts